module.exports = __webpack_public_path__ + "img/partner02.a1380af1.png";